import lineChart from './lineChart';

const ivSkewChart = {
  options: {
    ...lineChart.options,
    yaxis: {
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 600,
          colors: ['#8c8c8c'],
        },
        formatter: (value) => {
          return value.toFixed(4);
        },
      },
    },
    tooltip: {
      x: {
        format: 'yyyy-MM-dd HH:mm',
      },
      y: {
        formatter: function (val) {
          return val.toFixed(4);
        },
      },
    },
  },
};

export default ivSkewChart;
